module.exports = __webpack_public_path__ + "img/retail.2a442b1e.svg";